"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConvertItemValue = void 0;
const createConvertItemValue = (createConvertItemArray, createConvertItemObject, isBooleanItemValue, isListItemValue, isMapItemValue, isNullItemValue, isNumberItemValue, isStringItemValue) => {
  const convertItemValue = value => {
    if (isBooleanItemValue(value)) {
      return value.BOOL;
    }
    if (isListItemValue(value)) {
      return convertItemArray(value.L);
    }
    if (isMapItemValue(value)) {
      return convertItemObject(value.M);
    }
    if (isNumberItemValue(value)) {
      if (/\./.test(value.N)) {
        return parseFloat(value.N);
      }
      return parseInt(value.N, 10);
    }
    if (isNullItemValue(value)) {
      return null;
    }
    if (isStringItemValue(value)) {
      return value.S;
    }
    throw new Error('Unsupported data type');
  };
  const convertItemArray = createConvertItemArray(convertItemValue);
  const convertItemObject = createConvertItemObject(convertItemValue);
  return convertItemValue;
};
exports.createConvertItemValue = createConvertItemValue;